import { ProviderAuthenticationCommon } from '~/plugins/data-connector/authentication/common'

export const ProviderTaskCommon = {
  key: 'task',
  authentication: ProviderAuthenticationCommon.Form(),
}

export type ProviderTaskAccountType = null
